import { render } from "./campaign-card.vue?vue&type=template&id=99df1eda&scoped=true"
import script from "./campaign-card.vue?vue&type=script&lang=js"
export * from "./campaign-card.vue?vue&type=script&lang=js"

import "./campaign-card.vue?vue&type=style&index=0&id=99df1eda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99df1eda"]])

export default __exports__